import { authentication } from '@perpay-web/authentication/singleton';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    passkeyRegisterComplete,
    passkeyRegisterCompleteSuccess,
    passkeyRegisterCompleteError,
    passkeyRegisterCompleteReset,
} from '@perpay-web/fintech/actions/passkey';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const usePasskeyRegisterCompleteDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authentication.passkeyRegisterComplete(payload),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: passkeyRegisterComplete,
        success: passkeyRegisterCompleteSuccess,
        error: passkeyRegisterCompleteError,
        reset: passkeyRegisterCompleteReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = usePasskeyRegisterCompleteDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [UsePasskeyRegisterCompleteDataModuleProvider] =
    createContextProvider(providerFactory);
